import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export interface IConsolidationParms {
  className?: string
}

const useStyles: () => Record<string, string> = makeStyles((theme: Theme) => ({

  boundingRect: {
    fill: '#d9f1fd',
    stroke: '#204284',
    strokeMiterLimit: '10',
    strokeWidth: '20px',
  },

  circle: {
    fill: '#129cd8',
  },

  arrow: {
    fill: '#204284',
  },

}));


// By wrapping this component's definition in React.forwardRef, we enable having the ability to accept a React.Ref (ref?) parameter, in addition to the 
// normal 'props' parameter collection. The 'ref' allows us to forward the embedded <svg> element as a DOM reference
const Consolidation = React.forwardRef((props: IConsolidationParms, ref?: React.Ref<SVGSVGElement>) => {

  const { className } = props;
  const classes: Record<string, string> = useStyles();

  return (
    <svg ref={ref} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520 520" >
      <defs>
      </defs>
      <g id="ConsolidationIcon">

        <rect id="BorderAndBackground" className={classes.boundingRect} x="10" y="10" width="500" height="500" rx="10.44" ry="10.44" />

        <g id="CirclesAndArrows">
          <path className={classes.arrow} d="M483.21,258.93c0-.34-.19-.64-.49-.79l-95.73-47.42c-.27-.14-.6-.12-.86.04-.26.16-.42.45-.42.76l.12,32.23-95.77.36h0s-.08-.02-.12-.02c-39.1-.44-71.5-28.95-77.92-66.37h0c26.87-7.41,46.56-32.07,46.45-61.29-.13-34.97-28.59-63.21-63.56-63.09-34.97.13-63.22,28.59-63.09,63.56.11,29.92,20.95,54.91,48.86,61.43h0c3.31,25.85,15.5,48.92,33.4,66.05h0s-52.62.2-52.62.2h0c-7.04-27.43-31.97-47.66-61.57-47.55-34.97.13-63.22,28.59-63.09,63.56.13,34.97,28.59,63.22,63.56,63.09,29.61-.11,54.39-20.52,61.22-48h0s52.6-.2,52.6-.2h0c-17.76,17.29-29.77,40.44-32.88,66.31h0c-27.86,6.72-48.51,31.87-48.4,61.78.13,34.97,28.59,63.22,63.56,63.09,34.97-.13,63.22-28.59,63.09-63.56-.11-29.21-19.98-53.73-46.9-60.94,6.13-37.42,38.26-66.15,77.29-66.95.02,0,.04,0,.06,0h0s95.98-.36,95.98-.36l.12,32.23c0,.31.16.59.43.75.26.16.59.18.86.04l95.38-48.13c.3-.15.49-.46.49-.8h0ZM227.36,116.55c.07,17.8-14.31,32.28-32.11,32.35-17.8.07-32.28-14.31-32.35-32.11-.07-17.8,14.31-32.28,32.11-32.35,17.8-.07,32.28,14.31,32.35,32.11h0ZM228.43,403.21c.07,17.8-14.31,32.28-32.11,32.35-17.8.07-32.28-14.31-32.35-32.11-.07-17.8,14.31-32.29,32.11-32.35,17.8-.07,32.28,14.31,32.35,32.11h0ZM132.34,260.24c.07,17.8-14.31,32.28-32.11,32.35-17.8.07-32.29-14.31-32.35-32.11-.07-17.8,14.31-32.28,32.11-32.35,17.8-.07,32.29,14.31,32.35,32.11h0ZM132.34,260.24" />
          <ellipse className={classes.circle} cx="195.66" cy="116.67" rx="32.76" ry="32.23" />
          <ellipse className={classes.circle} cx="100.64" cy="260.35" rx="32.76" ry="32.23" />
          <ellipse className={classes.circle} cx="196.2" cy="403.33" rx="32.76" ry="32.23" />
        </g>

      </g>

    </svg >
  )
});

export default Consolidation;
